import './style.scss';

import Container from "./container";
export default Container;